import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=e5ca520c&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=e5ca520c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ca520c",
  null
  
)

export default component.exports